import $ from 'jquery'
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import { ref } from 'vue'

export default {
    name: 'examen-clinique-modal',
    components: {VueEditor},
    props: {
        consultation_id: Number,
        evolution_id: Number,
        group_id: Number,
        user_id: Number,
        info_user: Object,
        appareil_a_examiner: Object,
        to_be_deleted: Object,
        toggle_modal_examination: Boolean
    },
    data() {
        return {
            selectedOrganes: [],
            loading: false,
            modification: false,

            // ---------
            selected_appareils: [],
            save_loading: false,
            choice_is_empty: false,

            appareil: '',
            is_exist: false,

            observation: '',
            del_loading: false,
            is_confirm: false,

            is_error: false,
            permission_is_denied: false,
            customToolbar: vueEditorToolbar,

            is_recording: ref(false),

            recognition: null,
            transcript: '',
            is_listening: false,
            recognition_err_msg: ''
        }
    },

    watch: {
        selected_appareils() {
            this.choice_is_empty = false
        }, 

        group_id() {
            this.permission_is_denied = false
            this.choice_is_empty = false
            this.is_error = false
            this.selected_appareils = []
        }, 

        to_be_deleted() {
            this.permission_is_denied = false
            this.is_confirm = false
        },

        toggle_modal_examination() {
            if (this.is_listening) {
                this.stopRecording()
            }
            
            this.observation = ''
            this.appareil_a_examiner.observations.forEach(observation => {
                this.observation += observation.observation
            });
        },

        // appareilToExamine() {
        //     this.observation = this.appareilToExamine?.observation; //Set existing appareil observation
        // }
    },

    computed: {
        organes() {
            return this.$store.getters['organe_a_examiner']
        },

        consultationEnCours() {
            return this.$store.getters["consultationPatientEnCours"]
        },

        type_appareils() {
            return this.$store.getters["type_appareils"];
        },

        // appareilToExamine() {
        //     return this.$store.getters["appareil_a_examiner"];
        // }
    },

    mounted() {
        this.$store.dispatch('getOrganesAExaminerNotSelected', this.consultationEnCours.id)

        this.getListeTypeAppareils();
    },
    
    methods: {
        getListeTypeAppareils() {
            this.$store.dispatch("getTypeAppareils")
        },

        save() {
            this.permission_is_denied = false
            this.is_error = false

            if (this.selected_appareils.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.save_loading = true

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: this.info_user,
                selected_appareil: this.selected_appareils
            }

            this.$store.dispatch('storeAppareilAExaminer', data).then((response) => {
                if (response > 0) {
                    this.successToast("Appareil ajouté avec succès")
                    this.$emit('emitAppareilAExaminer')

                    this.$refs.modal_exm_clinique.click();
                    this.selected_appareils = []
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }
                
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        async saveExamination() {
            const isValid = await this.$refs.observation_form.validate();

            if (!isValid) {
                return;
            }
            this.save_loading = true

            let data = {
                consultation_id: this.consultation_id,
                group_id: this.appareil_a_examiner.group_id,
                observation: this.observation,
                consultation_appareil_id: parseInt(this.appareil_a_examiner.consultation_appareil_id),
                type_appareil_id: this.appareil_a_examiner.appareil_id
            }
            this.$store.dispatch('saveObservationAppareil', data).then((response) => {
                if (response.success) {
                    this.successToast("Observation ajoutée avec succès")

                    this.observation = ''
                    this.$refs.modal_observation.click();
                    this.$refs.observation_form.reset();

                    this.$emit('emitAppareilAExaminer')
                }

                this.save_loading = false
            })

        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                group_id: this.to_be_deleted.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                type_appareil_id: this.to_be_deleted.type_appareil_id,
                id: this.to_be_deleted.id
            }

            this.$store.dispatch('deleteAppareilObservation', data).then((response) => {
                if (response > 0) {
                    this.successToast("Observation supprimée avec succès")
                    this.$emit('emitAppareilAExaminer')

                    this.is_confirm = false
                    this.$refs.del_obs.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },

        deleteAppareil(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                appareil_id: this.to_be_deleted.id,
                consultation_id: this.to_be_deleted.consultation_id,
                group_id: this.to_be_deleted.group_id,
                evolution_id: this.to_be_deleted.evolution_id,
                user_id: this.user_id
            }

            this.$store.dispatch('deleteAppareilFromExamenClinique', data).then((response) => {
                if (response > 0) {
                    this.successToast("Appareil supprimé avec succès")
                    this.$emit('emitAppareilAExaminer')

                    this.is_confirm = false
                    this.$refs.del_appareil.click();
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }
                this.del_loading = false
            }).catch(() => {
                this.is_error = true
                this.del_loading = false
            })
        },

        deleteGroupAppareil(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                consultation_id: this.to_be_deleted.consultation_id,
                group_id: this.to_be_deleted.group_id,
                evolution_id: this.to_be_deleted.evolution_id,
                user_id: this.user_id
            }

            this.$store.dispatch('deleteGroupAppareilFromExamenClinique', data).then((response) => {
                if (response > 0) {
                    this.successToast("Suppression effectuée avec succès")
                    this.$emit('emitAppareilAExaminer')

                    this.is_confirm = false
                    this.$refs.del_grp_appareil.click();
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }
                this.del_loading = false
            }).catch(() => {
                this.is_error = true
                this.del_loading = false
            })
        },


        emitToExamenClinique: function () {
            this.$emit('modalToForm', this.consultationEnCours)
        },

        addAppareil() {
            this.modification = !this.modification
        },


        async submit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) {
                return;
            } 

            this.save_loading = true
            const data = {
                id: 0,
                libelle: this.appareil
            }

            this.$store.dispatch('storeAppareil', data).then((response) => {
                if (response > 0) {
                    this.successToast("Appareil ajouté avec succès")
                    this.getListeTypeAppareils()
                    this.addAppareil()

                    this.appareil = ''
                } else if (response == -1) {
                    this.is_exist = true
                }
                this.save_loading = false
            })
        },

        clearError() {
            this.is_exist = false
        },

        removeParagraph(text) {
            return text?.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },

        recordSpeech() {
            this.recognition_err_msg = ''
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!SpeechRecognition) {
                this.recognition_err_msg = "La conversion Audio-Text n'est pas supportée par votre navigateur ! "+
                    "Merci d'utiliser un navigateur moderne comme Google Chrome ou Microsoft Edge."
                return
            }
            this.is_listening = true

            this.recognition = new SpeechRecognition()
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'fr-FR'

            this.recognition.onend = () => {
                this.is_listening = false
            }

            this.recognition.onresult = (evt) => {
                for (let i = evt.resultIndex; i < evt.results.length; ++i) {
                    this.$refs.exm_editor.quill.blur()

                    this.transcript = evt.results[i][0].transcript

                    this.observation = this.removeParagraph(this.observation)
                    if (evt.results[i].isFinal) {
                        this.observation += this.transcript
                    } 
                }
            }

            this.recognition.onerror = (evt) => {
                this.recognition_err_msg = "Une erreur est survenue lors de la conversion Audio-Text. "+
                    "Merci de vérifier votre connexion internet !"
                console.log("Speech recognition error: ",evt);
                this.recognition.stop();
                this.is_listening = false;
            }

            this.recognition.start()
        },

        stopRecording() {
            this.recognition_err_msg = ''
            this.recognition.stop();
            this.is_listening = false;
        
            // Optional: Clear the transcript if you want to start fresh next time
            this.transcript = ""; 
        }
    }
}